import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const generateStreamToken = httpsCallable(functions, 'generateStreamToken');

export const streamTokenProvider = async (userId) => {
  const res = await generateStreamToken({ userId });
  // Cloud function returns the token string directly (see ../app/firebase/functions/chat/streamToken.js)
  if (typeof res?.data === 'string') return res.data;
  if (res?.data?.token) return res.data.token;
  throw new Error('Invalid Stream token response');
};

// Stream's connectUser accepts () => Promise<string> for auto-refresh; bind the uid.
export const tokenProviderFor = (userId) => () => streamTokenProvider(userId);
